import React from 'react';
import { TopToolbar } from 'react-admin';
import './TopToolbar.scss';

const CustomTopToolbar = (props) => <TopToolbar className="CustomToolbar" {...props} />;

export default CustomTopToolbar;
